(function () {
  'use strict';
  var page = document.querySelector('.bw-wishlist-page');
  if (!page || page.dataset.enhanced) return;
  page.dataset.enhanced = 'true';
  var root = page.querySelector('#swym-wishlist-render-container');
  var count = page.querySelector('[data-bw-wishlist-count]');
  var content = page.querySelector('[data-bw-wishlist-content]');
  var skeleton = page.querySelector('[data-bw-wishlist-skeleton]');
  var recovery = page.querySelector('[data-bw-wishlist-recovery]');
  var retry = page.querySelector('[data-bw-wishlist-retry]');
  var settings = page.querySelector('[data-bw-wishlist-settings]');
  var notice = page.querySelector('[data-bw-wishlist-notice]');
  var settingsError = page.querySelector('[data-bw-wishlist-settings-error]');
  if (!count) return;
  var queued = false;
  var deadline = Date.now() + 10000;
  var privacyPoll;
  function preferencesAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return privacy && typeof privacy.preferencesProcessingAllowed === 'function'
        ? privacy.preferencesProcessingAllowed() : null;
    } catch (_) { return null; }
  }
  function status(state) {
    page.dataset.loadState = state;
    var loading = state === 'loading';
    var label = state === 'consent' ? page.dataset.consentLabel
      : loading ? page.dataset.loadingLabel : page.dataset.slowLabel;
    if (count.textContent !== label) count.textContent = label;
    if (skeleton) skeleton.hidden = !loading;
    if (content) {
      content.hidden = state === 'consent';
      content.setAttribute('aria-busy', String(loading));
    }
    if (recovery) recovery.hidden = loading;
    if (retry) retry.hidden = state === 'consent';
    var detail = state === 'consent' ? page.dataset.consentNotice : page.dataset.slowNotice;
    if (notice && notice.textContent !== detail) notice.textContent = detail;
  }
  function watchLoading() {
    clearInterval(privacyPoll);
    privacyPoll = setInterval(function () {
      sync();
      if (page.dataset.loadState === 'ready' || Date.now() >= deadline) clearInterval(privacyPoll);
    }, 500);
  }
  if (retry) retry.addEventListener('click', function (event) {
    event.preventDefault();
    if (preferencesAllowed() === false) { status('consent'); return; }
    // Re-run the app's own initialization; never clear its saved data or cookies.
    window.location.reload();
  });
  if (settings) settings.addEventListener('click', function () {
    if (settingsError) settingsError.hidden = true;
    var banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') {
      if (settingsError) settingsError.hidden = false;
      return;
    }
    settings.disabled = true;
    var settled = false;
    function finish(failed) {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      settings.disabled = false;
      if (settingsError) settingsError.hidden = !failed;
    }
    var timeout = setTimeout(function () { finish(true); }, 10000);
    try { Promise.resolve(banner.showPreferences()).then(function () { finish(false); }, function () { finish(true); }); }
    catch (_) { finish(true); }
  });
  document.addEventListener('visitorConsentCollected', function () {
    if (settingsError) settingsError.hidden = true;
    deadline = Date.now() + 10000;
    sync();
    watchLoading();
  });

  function productURL(card) {
    var image = card.querySelector('a.swym-wishlist-image-wrapper');
    if (!image) return null;
    try {
      var url = new URL(image.getAttribute('href'), location.href);
      return url.origin === location.origin && /\/products\/[^/]+/.test(url.pathname) ? url.href : null;
    } catch (_) { return null; }
  }

  function sync() {
    queued = false;
    if (preferencesAllowed() === false) { status('consent'); return; }
    if (content) content.hidden = false;
    root = page.querySelector('#swym-wishlist-render-container');
    var cards = root ? root.querySelectorAll('.swym-wishlist-grid .swym-wishlist-item') : [];
    var empty = root && root.querySelector('.swym-empty-wishlist-container');
    if (cards.length || empty) {
      clearInterval(privacyPoll);
      if (page.dataset.loadState !== 'ready') {
        page.dataset.loadState = 'ready';
        if (skeleton) skeleton.hidden = true;
        if (recovery) recovery.hidden = true;
        if (content) content.setAttribute('aria-busy', 'false');
      }
      var suffix = cards.length === 1 ? page.dataset.itemLabel : page.dataset.itemsLabel;
      var label = cards.length + ' ' + (suffix || (cards.length === 1 ? 'saved item' : 'saved items'));
      if (count.textContent !== label) count.textContent = label;
    } else status(Date.now() >= deadline ? 'slow' : 'loading');
    cards.forEach(function (card) {
      var href = productURL(card);
      if (!href) return;
      var view = card.querySelector('.bw-wishlist-view');
      if (!view) {
        view = document.createElement('a');
        view.className = 'bw-wishlist-view';
        view.textContent = 'VIEW PRODUCT';
        // Do not let Swym's enclosing card open a second product popover.
        view.addEventListener('click', function (event) { event.stopPropagation(); });
        view.addEventListener('keydown', function (event) { event.stopPropagation(); });
        card.appendChild(view);
      }
      if (view.href !== href) view.href = href;
      var title = card.querySelector('.swym-title');
      var label = 'View ' + (title ? title.textContent.trim() : 'product');
      if (view.getAttribute('aria-label') !== label) view.setAttribute('aria-label', label);
      card.classList.add('bw-wishlist-card-ready');
      var imageLink = card.querySelector('a.swym-wishlist-image-wrapper');
      var variantId = new URL(href).searchParams.get('variant');
      if (variantId && window.BWWishlistImages) {
        var image = imageLink.querySelector('img');
        if (!image) {
          image = document.createElement('img'); image.alt = title ? title.textContent.trim() : 'Saved product';
          image.width = 480; image.height = 480; image.loading = 'lazy'; imageLink.appendChild(image);
        }
        window.BWWishlistImages.watch(image,{variantId:variantId},function (resolved) {
          imageLink.href = resolved.href; view.href = resolved.href;
        });
      }
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  // Also catch a late app mount. State/count writes are guarded to avoid observer loops.
  new MutationObserver(schedule).observe(page, { childList: true, subtree: true, characterData: true });
  sync();
  watchLoading();
  document.addEventListener('DOMContentLoaded',schedule,{once:true});
})();
